<template>
  <van-popup
    closeable
    position="bottom"
    round
    @click-overlay="close"
    @click-close-icon="close"
    @close="close"
    :value="value"
  >
    <div class="wrap">
      <svg-icon icon-class="close-white" class="icon" />
      <div class="title">尊敬的用户您好：</div>
      <div class="content">
        尊敬的用户您好：部分偏远地区因物流距离远、配送成本较高，需加收运费，具体运费金额将在下单后由客服人员电话联系，请留意接听。
      </div>
      <div class="footer">
        <div class="accept-btn" @click="accept">接受运费</div>
        <div class="choose-btn" @click="choose">重新选择</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Vue from "vue";
import router from '@/router';
import { defineComponent } from "@vue/composition-api";

const vm = Vue.prototype;

export default defineComponent({
  props: {
    from: {
      type: String,
      default: "visitor",
    },
    value: Boolean,
    close: {
      type: Function,
      default() {},
    },
    resolve: Function,
    reject: Function,
  },
  setup(props) {
    const accept = async () => {
      props.close();
      props.resolve(true);
    };

    const choose = async () => {
      props.close();
      props.resolve(false);
      const indexUrl = vm.$getConfigValue("INDEX_URL") || "/index";
      router.replace(indexUrl);
    };

    return {
      accept,
      choose,
    };
  },
});
</script>

<style lang="less" scoped>
.wrap {
  height: 243px;
  background: #f8f8f8;
  border-radius: 16px 16px 0px 0px;
  padding: 36px 14px 38px 16px;

  .icon {
    font-size: 12px;
  }

  .title {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 24px;
    text-align: left;
  }

  .content {
    margin-top: 9px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 24px;
  }

  .footer {
    display: flex;
    margin-top: 16px;
    justify-content: space-between;

    .footer-btn {
      width: 164px;
      height: 48px;
      border-radius: 24px;
      border: 1px solid #d9dbe0;
    }

    .accept-btn {
      width: 164px;
      height: 48px;
      border-radius: 24px;
      border: 1px solid #d9dbe0;

      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      text-align: center;
      line-height: 48px;
    }

    .choose-btn {
      width: 164px;
      height: 48px;
      background: linear-gradient(115deg, #dfbd94 0%, #ffe8c8 100%);
      border-radius: 24px;

      font-weight: 500;
      font-size: 16px;
      color: #6c3e0c;
      line-height: 22px;
      text-align: center;
      line-height: 48px;
    }
  }
}
</style>
